import PrimaryPalette from '../../colors';

const tagTheme = {
  status: {
    backgroundColor: PrimaryPalette.darkGreen,
    fontColor: PrimaryPalette.white,
  },
  important: {
    backgroundColor: PrimaryPalette.lightEvergreen,
    fontColor: PrimaryPalette.white,
  },
  private: {
    backgroundColor: PrimaryPalette.mediumGrey,
    fontColor: PrimaryPalette.mediumEvergreen,
  },
};

export default tagTheme;
